import css from "styled-jsx/css";
export default css`
  @import "src/static/styles/variables";
  @import "src/static/styles/mixins/mixins";
  .full-screen-overlay {
    float: left;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.15);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9300;
  }
  .agent-search-loading-container .loading-text {
    position: relative;
    width: 80px;
    height: 80px;
    top: 40%;
    margin: 0 auto 0 auto;
    // background-color: #fff;
    // color: $brand-primary;
    // border-radius: 6px;
    // text-align: center;
  }
  .agent-search-loading-container .loading-text i {
    // font-size: 30px;
    // line-height: 80px;
  }
`;
